import { NgModule } from "@angular/core";
import { AddNewAdvertisementDialogComponent } from "./add-new-advertisement/add-new-advertisement.component";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "@angular/material";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AdvertisementRoutingModule } from "./advertisement-routing.module";

@NgModule({
    imports:[
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        AdvertisementRoutingModule
    ],
    declarations:[
        AddNewAdvertisementDialogComponent
    ]
})
export class AdvertisementModule{}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/advertisement/advertisement.module.ts